/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import ApiServices from "../../utils/apiServices";
import { imsLoader } from "../../assets";

class ManageInternalUsersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      internalUsers: [],
      isLoading: false,
      internalUserSearch: "",
      internalUserSearchResults: [],
      internalUserSearchLoading: false,
    };
  }

  async componentDidMount() {
    await this.loadInternalUsers();
  }

  loadInternalUsers = async () => {
    this.setState({ isLoading: true });
    const apiServices = new ApiServices();
    const users = await apiServices.getInternalUsers();
    this.setState({ internalUsers: users || [], isLoading: false });
  };

  handleSearchChange = async (e) => {
    const query = e.target.value;
    this.setState({ internalUserSearch: query, internalUserSearchResults: [], internalUserSearchLoading: !!query });
    if (!query) return;
    const apiServices = new ApiServices();
    const results = await apiServices.searchNonInternalUsers(query);
    this.setState({ internalUserSearchResults: results || [], internalUserSearchLoading: false });
  };

  addToInternalUsers = async (user) => {
    this.setState({ isLoading: true });
    const apiServices = new ApiServices();
    await apiServices.setUserInternalStatus(user.wwid, true);
    const users = await apiServices.getInternalUsers();
    this.setState({ internalUsers: users || [], isLoading: false, internalUserSearch: "", internalUserSearchResults: [] });
  };

  removeFromInternalUsers = async (wwid) => {
    this.setState({ isLoading: true });
    const apiServices = new ApiServices();
    await apiServices.setUserInternalStatus(wwid, false);
    const users = await apiServices.getInternalUsers();
    this.setState({ internalUsers: users || [], isLoading: false });
  };

  handleClose = () => {
    this.setState({ internalUserSearch: "", internalUserSearchResults: [] });
    if (this.props.onClose) this.props.onClose();
  };

  render() {
    const { show } = this.props;
    const { internalUsers, isLoading, internalUserSearch, internalUserSearchResults, internalUserSearchLoading } = this.state;

    if (!show) return null;

    return (
      <div className="manage-internal-users-overlay" onClick={this.handleClose}>
        <div className="manage-internal-users-modal" onClick={e => e.stopPropagation()}>
          <div className="manage-internal-users-header">
            <span>Manage Internal Users</span>
            <button className="manage-internal-users-close" onClick={this.handleClose}>&#10005;</button>
          </div>
          <div className="manage-internal-users-body" style={{ position: 'relative' }}>
            {isLoading && (
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.7)', zIndex: 10 }}>
                <img src={imsLoader} alt="Loading" style={{ width: 60 }} />
              </div>
            )}
            <div className="manage-internal-users-search-section">
              <label><b>Add Non-Internal User to Internal List:</b></label>
              <input
                type="text"
                className="manage-internal-users-search-input"
                placeholder="Search by name, email, or WWID"
                value={internalUserSearch}
                onChange={this.handleSearchChange}
                disabled={isLoading}
              />
              {internalUserSearchLoading && <span style={{ marginLeft: 8, fontSize: 12 }}>Searching...</span>}
              {internalUserSearchResults.length > 0 && (
                <div className="manage-internal-users-search-results">
                  <table className="manage-internal-users-table">
                    <thead>
                      <tr>
                        <th>WWID</th><th>Name</th><th>Email</th><th>Region</th><th>Function</th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {internalUserSearchResults.map(u => (
                        <tr key={u.wwid}>
                          <td>{u.wwid}</td>
                          <td>{u.usertitle}</td>
                          <td>{u.email}</td>
                          <td>{u.region}</td>
                          <td>{u.function}</td>
                          <td>
                            <button className="manage-internal-users-add-btn" onClick={() => this.addToInternalUsers(u)} disabled={isLoading}>Add</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {!internalUserSearchLoading && internalUserSearch && internalUserSearchResults.length === 0 && (
                <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>No results found.</div>
              )}
            </div>
            <div className="manage-internal-users-list-section">
              <label><b>Current Internal Users:</b></label>
              <div className="manage-internal-users-table-wrapper">
                <table className="manage-internal-users-table">
                  <thead>
                    <tr>
                      <th>WWID</th><th>Name</th><th>Email</th><th>Region</th><th>Function</th><th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {internalUsers.length === 0 ? (
                      <tr><td colSpan={6} style={{ textAlign: 'center', color: '#888' }}>No internal users found.</td></tr>
                    ) : (
                      internalUsers.map(u => (
                        <tr key={u.wwid}>
                          <td>{u.wwid}</td>
                          <td>{u.usertitle}</td>
                          <td>{u.email}</td>
                          <td>{u.region}</td>
                          <td>{u.function}</td>
                          <td>
                            <button className="manage-internal-users-remove-btn" onClick={() => this.removeFromInternalUsers(u.wwid)} disabled={isLoading}>Remove</button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ManageInternalUsersModal;

